import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { projectSaveStore } from "@/hooks";
import { TextButton, FlexBox, List } from "@/components/common";
import UploadPanel from "./UploadPanel.vue";


/**
 * Provides inputs for uploading files.
 */
const __default__ = {
  name: "UploadPanelList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const panels = computed(() => projectSaveStore.uploadPanels);

// Only allow multiple uploads when uploading individual files.
const allowMultiple = computed(() =>
  panels.value.reduce(
    (acc, { variant }) =>
      acc && (variant === "artifact" || variant === "trace"),
    true
  )
);

/**
 * Adds a new panel.
 */
function handleAddPanel(): void {
  projectSaveStore.addPanel("artifact");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(List), { class: "q-mb-lg" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panels.value, (panel, idx) => {
          return (_openBlock(), _createBlock(UploadPanel, {
            key: idx,
            panel: panel,
            index: idx
          }, {
            panel: _withCtx(() => [
              _renderSlot(_ctx.$slots, "panel", { panel: panel })
            ]),
            _: 2
          }, 1032, ["panel", "index"]))
        }), 128))
      ]),
      _: 3
    }),
    _createVNode(_unref(FlexBox), { justify: "center" }, {
      default: _withCtx(() => [
        (allowMultiple.value)
          ? (_openBlock(), _createBlock(_unref(TextButton), {
              key: 0,
              text: "",
              icon: "add",
              label: "New Upload",
              "data-cy": "button-add-panel",
              onClick: handleAddPanel
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})